import React, {useEffect, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import SubsiteService from "../../services/subsite.service";
import { getAllSubsites, allSubsites } from '../../reducers/subsite';

const UserSubsiteModal = (props) => {
  const dispatch = useDispatch();
  const { isSubmitting } = useState(false);
  const [subsite, setSubsite] = useState(null);
  const subsites = useSelector(allSubsites);
  
  const modalClose = () => {
    props.closeModal(false);
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    SubsiteService.setUserSubsite(props.user.id, subsite);
//    props.closeModal(false);
  }
  
  useEffect(() => {
    dispatch(getAllSubsites([1,1000]));
  },[dispatch]);

  return (
    <Modal show={props.show} onHide={modalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Update Roles<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <Form onSubmit={handleSubmit} >
              <Form.Group className="mb-3" controlId="state">
                <Form.Select aria-label="Default select example" onChange={(e) => setSubsite(e.target.value)}>
                    <option>Select Subsite</option>
                    {subsites.map(subsite => (
                        <option value={subsite.id}>{subsite.subsiteName}</option>
                    ))}
                </Form.Select>
              </Form.Group>
              <Modal.Footer>
                <Button variant="secondary" onClick={modalClose}>
                  Close
                </Button>
                <Button variant="primary" onClick={handleSubmit} type="submit" disabled={isSubmitting}>
                  Add User to Subsite
                </Button>
              </Modal.Footer>
            </Form>  
    </Modal.Body>
    </Modal>
  );
};

export default UserSubsiteModal; 